import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User } from "lucide-react";
import api from "../../api";
import { TargetIcon } from "../../components/Logo";
import { useToast } from "../../hooks/use-toast";
import useSeo from "../../hooks/useSeo";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { toast } = useToast();
  useSeo("Admin Login | Morning Sunday Teer", "", { robots: "noindex, nofollow" });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.login(username.trim(), password);
      navigate("/admin/dashboard");
    } catch (err) {
      toast({
        title: "Login failed",
        description: "Invalid username or password.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen bg-[#f4f5f7] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white rounded-xl shadow-md border border-gray-200 p-7">
        <div className="flex flex-col items-center mb-6">
          <TargetIcon size={54} />
          <h1 className="text-xl font-bold text-[#1f2a37] mt-3">Admin Login</h1>
          <p className="text-xs text-gray-500 mt-1">Morning Sunday Teer</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#5b6b7b] mb-1">
              Username
            </label>
            <div className="relative">
              <User className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full border border-gray-300 rounded-md pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7fb5]"
                placeholder="admin"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-[#5b6b7b] mb-1">
              Password
            </label>
            <div className="relative">
              <Lock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-md pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7fb5]"
                placeholder="••••••••"
              />
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-[#4a7fb5] hover:bg-[#3d6c9c] text-white font-medium py-2.5 rounded-md transition-colors"
          >
            Login
          </button>
        </form>
        <p className="text-xs text-gray-400 text-center mt-4">
          Default: admin / admin123
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
